import React from "react"

export default function Space({ size = 1 }) {
	return <div className="Space" style={{ height: size * 2 + "rem" }}></div>
}
